import getCommonResponse from '../actions/Common';
import Cookies from 'js-cookie'

function RefreshToken(callAPI) {
    console.log("checkrefresh");
    const accesstoken =  Cookies.get('access_token');
    const refreshtoken = Cookies.get('refresh_token');
    console.log("[Re] accesstokenjs", accesstoken);
    console.log("[Re] refreshtokenjs", refreshtoken);
    if(accesstoken && refreshtoken) {
        const decode = JSON.parse(atob(accesstoken.split('.')[1]));
        let expiration = new Date(decode.exp * 1000).getTime();
        let now = new Date().getTime();
        let expirationminutes = expiration/60000;
        let nowminutes = now/60000;
        console.log("refreshexpirationminutes", expirationminutes);
        console.log("refreshnowminutes", nowminutes);
        if((expirationminutes - nowminutes) < 2) {
            const URL = '/api/users/refreshtoken';
            let formData = new FormData();
            formData.set('refreshtoken', refreshtoken);
            console.log("formdata", formData);
            getCommonResponse.GetRefreshResponse(URL, formData, (response) => {
                console.log("refreshresponse", response);
                if(response && response.status === 200) {
                    console.log('success')
                    const accessTokennew = response && response.data && response.data.accessToken;
                    const refreshTokennew = response && response.data && response.data.data && response.data.data.refreshToken;
                    Cookies.set('access_token', accessTokennew);
                    Cookies.set('refresh_token', refreshTokennew);
                    callAPI(accessTokennew);
                }
                if(response && response.status === 401) {
                    console.log('successfailure');
                    Cookies.remove('access_token');
                    Cookies.remove('refresh_token');
                    callAPI('');
                }
            });
        }
        else {
            callAPI(accesstoken);
            console.log("else")
        }
    }
    else {
        console.log("[Re] No token")
        callAPI('noToken');
    }
}

export default RefreshToken;
